import { adminApi } from '../../../store/generated/admin/organization-records';
import { UserContextApiTags } from '../../../common/api/userContextApi';

export const OrganizationRecordApiTags = {
  OrganizationRecord: 'OrganizationRecord',
} as const;

const taggedApi = adminApi.enhanceEndpoints({addTagTypes: Object.values(OrganizationRecordApiTags),});

export const organizationRecordApi = taggedApi.enhanceEndpoints({
  addTagTypes: [
    OrganizationRecordApiTags.OrganizationRecord,
    UserContextApiTags.OrganizationContext,
  ],
  endpoints: {
    apiAdminV1OrganizationRecordsList: {
      providesTags: [OrganizationRecordApiTags.OrganizationRecord],
    },
    apiAdminV1OrganizationRecordsCreate: {
      invalidatesTags: [
        OrganizationRecordApiTags.OrganizationRecord,
        UserContextApiTags.OrganizationContext,
      ],
    },
    apiAdminV1OrganizationRecordsRetrieve: {
      providesTags: [OrganizationRecordApiTags.OrganizationRecord],
    },
    apiAdminV1OrganizationRecordsUpdate: {
      invalidatesTags: [
        OrganizationRecordApiTags.OrganizationRecord,
        UserContextApiTags.OrganizationContext,
      ],
    },
    apiAdminV1OrganizationRecordsDestroy: {
      invalidatesTags: [
        OrganizationRecordApiTags.OrganizationRecord,
        UserContextApiTags.OrganizationContext,
      ],
    },
  },
});
